var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmoji(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.222,
    height: 39.221,
    viewBox: "0 0 39.222 39.221",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "mood_FILL0_wght400_GRAD0_opsz48",
    d: "M30.769,21.012a2.6,2.6,0,1,0-1.888-.76A2.563,2.563,0,0,0,30.769,21.012Zm-14.316,0a2.6,2.6,0,1,0-1.888-.76A2.563,2.563,0,0,0,16.453,21.012Zm7.158,13.335a10.837,10.837,0,0,0,5.957-1.74,9.981,9.981,0,0,0,3.947-4.731H13.707a10.315,10.315,0,0,0,3.971,4.731A10.717,10.717,0,0,0,23.611,34.347Zm0,8.874a18.976,18.976,0,0,1-7.6-1.544A19.758,19.758,0,0,1,5.544,31.21a19.589,19.589,0,0,1,0-15.247A19.6,19.6,0,0,1,9.761,9.736a20.1,20.1,0,0,1,6.251-4.192,19.59,19.59,0,0,1,15.247,0A19.58,19.58,0,0,1,41.677,15.962a19.589,19.589,0,0,1,0,15.247,20.1,20.1,0,0,1-4.192,6.251,19.6,19.6,0,0,1-6.226,4.216A19.1,19.1,0,0,1,23.611,43.221ZM23.611,23.611Zm0,16.669A16.04,16.04,0,0,0,35.426,35.4,16.1,16.1,0,0,0,40.28,23.611,16.081,16.081,0,0,0,35.426,11.8,16.081,16.081,0,0,0,23.611,6.942,16.1,16.1,0,0,0,11.82,11.8,16.04,16.04,0,0,0,6.942,23.611,16.063,16.063,0,0,0,11.82,35.4,16.064,16.064,0,0,0,23.611,40.28Z",
    transform: "translate(-4 -4)",
    fill: "#e30613"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmoji);
export default __webpack_public_path__ + "static/media/emoji.cd3ca20e71232c9b7737e66dce1473c8.svg";
export { ForwardRef as ReactComponent };